import React from 'react';

const base =
  'inline-flex items-center justify-center gap-2 font-medium whitespace-nowrap rounded-lg ' +
  'transition-colors duration-150 disabled:opacity-50 disabled:pointer-events-none';

const variants = {
  primary: 'bg-brand text-white hover:bg-brand-hover shadow-sm',
  secondary: 'bg-surface text-ink border border-line hover:bg-surface-hover',
  ghost: 'text-ink-muted hover:bg-surface-hover hover:text-ink',
  danger: 'bg-danger text-white hover:brightness-95 shadow-sm',
  subtle: 'bg-brand-subtle text-brand-ink hover:brightness-95',
};

const sizes = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-9 px-3.5 text-sm',
  lg: 'h-10 px-4 text-sm',
  icon: 'h-9 w-9',
};

const Spinner = () => (
  <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent" />
);

/**
 * Bouton unique de l'app. Remplace les dizaines de variantes ad hoc
 * écrites page par page.
 */
const Button = React.forwardRef(function Button(
  { children, variant = 'primary', size = 'md', icon, loading = false, className = '', type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={`${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
      disabled={props.disabled || loading}
      {...props}
    >
      {loading ? <Spinner /> : icon}
      {children}
    </button>
  );
});

export default Button;
